var _excluded = ["min", "max", "now"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from './ProgressBar';

var ProgressBarBimAdapter = function ProgressBarBimAdapter(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? NaN : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? NaN : _ref$max,
      _ref$now = _ref.now,
      now = _ref$now === void 0 ? NaN : _ref$now,
      props = _objectWithoutProperties(_ref, _excluded);

  // If any of min, max, or now are undefined the ProgressBar will be indeterminate
  var subtractMinFromNow = now - min;
  var nowInPercentage = subtractMinFromNow / max * 100;
  return /*#__PURE__*/React.createElement(ProgressBar, _extends({
    now: nowInPercentage
  }, props));
};

ProgressBarBimAdapter.propTypes = {
  /** Min value */
  min: PropTypes.number,

  /** Max value */
  max: PropTypes.number,

  /** Current value */
  now: PropTypes.number
};
export default ProgressBarBimAdapter;
//# sourceMappingURL=ProgressBarBimAdapter.js.map